import { UseFormReturn } from "react-hook-form";
import { RoadObj } from "../Road";
import { ICustomField } from "app/component/custom-property/types";

export const generateClassName = (
  readPermissions: string[],
  createPermissions: string[],
  editPermissions: string[],
  editMode: boolean,
  properties: string
): string => {
  let classes = [];
  if (editMode) {
    !readPermissions.includes(properties) && classes.push("d-none");
    !editPermissions.includes(properties) && classes.push("disabled");
    return classes.join(" ");
  }
  !createPermissions.includes(properties) && classes.push("disabled");
  return classes.join(" ");
};

export const validateRequiredCustomProperties = (
  methods: UseFormReturn<
    {
      customFields: ICustomField[];
    },
    any,
    undefined
  >,
  isEdit?: boolean
) => {
  let valid = true;
  const required = methods
    .getValues()
    ?.customFields?.filter((el) => el.required && el.isVisible);
  if (required?.length) {
    const exist = required.every((el) => {
      if (typeof el.value === "string") return !!el?.value?.trim();
      else return !!el.value;
    });
    if (!exist) {
      valid = false;
      methods.setError("customFields", { message: "required" });
    }
  }
  return valid;
};

export const getValues = (
  methods: UseFormReturn<
    {
      customFields: ICustomField[];
    },
    any,
    undefined
  >,
  isEdit?: boolean
) => {
  return methods.getValues()?.customFields?.flatMap((field) => {
    if (Array.isArray(field.value) || Array.isArray(field.defaultValue)) {
      if (
        !field?.value?.length &&
        Array.isArray(field.defaultValue) &&
        field?.defaultValue?.length
      ) {
        return field.defaultValue.map((item) => {
          return {
            parentkey: field.parentKey,
            percent: item.percent,
            key: item.key,
            customPropertyId: field.customPropertyId,
            customPropertyListValueId:
              field.isAllocationAvailable || field.isSelect
                ? Number(item.value)
                : undefined,
            nameEn:
              field.isAllocationAvailable || field.isSelect
                ? undefined
                : item.text,
            nameRu:
              field.isAllocationAvailable || field.isSelect
                ? undefined
                : item.text,
            isAllocation: field.isAllocationAvailable,
            id: isEdit ? Number(item.key) : undefined,
          };
        });
      } else if (Array.isArray(field.value)) {
        return field?.value?.map((item) => {
          return {
            parentkey: field.parentKey,
            key: item.key,
            percent: item.percent,
            customPropertyId: field.customPropertyId,
            customPropertyListValueId: Number(item.value),
            nameEn: item.text,
            nameRu: item.text,
            isAllocation: field.isAllocationAvailable,
            id: isEdit ? Number(item.key) : undefined,
          };
        });
      }
    } else if (field.value) {
      return {
        parentkey: field.parentKey,
        key: field.key,
        percent: undefined,
        customPropertyId: field.customPropertyId,
        customPropertyListValueId:
          field.isAllocationAvailable || field.isSelect
            ? Number(field.value) || Number(field.defaultValue?.value)
            : undefined,
        nameEn:
          field.isAllocationAvailable || field.isSelect
            ? undefined
            : field.value || undefined,
        nameRu:
          field.isAllocationAvailable || field.isSelect
            ? undefined
            : field.value || undefined,
        isAllocation: field.isAllocationAvailable,
        id: isEdit ? field.editId : undefined,
      };
    } else return [];
  });
};

export const validateAllocation = (
  methods: UseFormReturn<
    {
      customFields: ICustomField[];
    },
    any,
    undefined
  >
) => {
  const allocations = methods
    .getValues()
    ?.customFields?.filter((el) => el.isAllocationAvailable);
  let valid = true;
  let sum = 0;
  let text = "";
  allocations?.forEach((field) => {
    let allocation;
    if (Array.isArray(field.value) || Array.isArray(field.defaultValue)) {
      if (
        !field?.value?.length &&
        Array.isArray(field.defaultValue) &&
        field?.defaultValue?.length
      ) {
        allocation = field?.defaultValue;
      } else if (Array.isArray(field.value)) {
        allocation = field?.value;
      }
    }
    if (allocation) {
      const totalSum = allocation?.reduce(
        (item, acc) => item + (acc.percent || 0),
        0
      );
      sum = totalSum;
      if (totalSum !== 100) {
        valid = false;
        text = "validator.cost_center_percent";
      } else {
        const seenValues = new Set<string | number>();

        for (const item of allocation) {
          if (seenValues.has(item.value)) {
            valid = false;
            text = "validator.cost_center_duplicate";
          }
          seenValues.add(item.value);
        }
      }
    }
  });
  return [valid, sum, text];
};

export const validateRoad = (
  road: RoadObj,
  index: number,
  multiRoadMode: boolean
): boolean => {
  if (!road.validate) {
    return true;
  }
  if (road.departureFromCityId === 0 && index == 0) {
    return false;
  }
  if (road.arrivalToCityId === 0) {
    return false;
  }
  if (!road.startOn) {
    return false;
  }
  if (!road.endOn) {
    return false;
  }
  if (!multiRoadMode && road.startOn.valueOf() > road.endOn.valueOf()) {
    return false;
  }
  return true;
};
